const MESSAGE_KEY = 'musclelab-message';

export interface ICommunication {
  command: string;
  data?: any;
}

export const receiveMessage = (ev: any, cb: (m: ICommunication) => void) => {
  if (ev.key !== MESSAGE_KEY) {
    return;
  }
  const message: ICommunication = JSON.parse(ev.newValue);
  if (!message) {
    return;
  }

  cb(message);
};

export const sendMessage = (message: ICommunication) => {
  localStorage.setItem(MESSAGE_KEY, JSON.stringify(message));
  localStorage.removeItem(MESSAGE_KEY);
};
